import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box } from '@mui/material'

import Tooltip from '../common/Tooltip'

const CenteredBox = styled(Box)`
  display: inline-flex;
  align-items: center;
`

function Label({ label = '', tooltip = '' }) {
  if (label === '') return
  if (tooltip === '') return <>{label}</>
  return (
    <CenteredBox gap={1}>
      {label}
      <Tooltip info={tooltip} />
    </CenteredBox>
  )
}

Label.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.string
}

export default Label
